module.exports = __webpack_public_path__ + "img/hourglass-highduration.1aa87a20.svg";